import React from 'react';
import { AlertCircle, RefreshCw } from 'lucide-react';

const CreditReportError = ({ crifV4Error, report, message: directMessage, onRetry }) => {
  // Extract error message based on your standard payload structure
  const rawMessage =
    directMessage ||
    crifV4Error?.error?.credit_report_message?.message ||
    crifV4Error?.message ||
    report?.status?.message ||
    "";

  // Safeguard: Check if it's implicitly a success or completely empty
  const isSuccess = rawMessage?.toLowerCase().includes("success");
  if (!rawMessage || isSuccess) return null;

  // Formatter: Cleans snake_case and correctly sets Title Case
  const formatText = (text) =>
    text
      ?.replace(/_/g, " ")
      ?.toLowerCase()
      ?.replace(/\b\w/g, (c) => c.toUpperCase());

  return (
    <div className="w-full max-w-xl mx-auto bg-rose-50 border border-rose-200/70 rounded-2xl p-4 shadow-xs transition-all duration-200 animate-in fade-in slide-in-from-top-2">
      <div className="flex items-start gap-3.5">
        
        {/* Modern Icon Frame */}
        <div className="p-2 bg-rose-100 text-rose-600 border border-rose-200/40 rounded-xl shrink-0 shadow-3xs">
          <AlertCircle size={18} className="stroke-[2.5]" />
        </div>
        
        {/* Text Area */}
        <div className="flex-1 space-y-0.5 pt-0.5">
          <h4 className="text-xs font-extrabold text-rose-950 uppercase tracking-wider">
            Report Issue Encountered
          </h4>
          <p className="text-sm text-rose-800 font-medium leading-relaxed">
            {formatText(rawMessage)}
          </p>
        </div>

        {/* Optional Contextual Action Button */}
        {/* {onRetry && (
          <button
            type="button"
            onClick={onRetry}
            className="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-bold text-rose-700 bg-white hover:bg-rose-100/70 border border-rose-200 rounded-xl transition-all duration-150 active:scale-[0.98] shadow-3xs self-center"
          >
            <RefreshCw size={12} className="animate-hover:spin" />
            Retry
          </button>
        )} */}
        
      </div>
    </div>
  );
};

export default CreditReportError;